import { Locales, usePrevioCore } from '@previo/core'
import { computed } from 'vue'
import { DATE_TIME_FORMATS, type DateTimeFormats } from './date-time'

type TUseFormat = {
  dateTime: DateTimeFormats
}

export const useFormat = (forceLocale?: Locales): TUseFormat => {
  const locale = forceLocale || usePrevioCore().useLocale().get()

  const dateTime = computed<DateTimeFormats>(() => {
    return DATE_TIME_FORMATS[locale]
  })

  return {
    dateTime: dateTime.value,
  }
}
